var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.question.image)?_c('div',{staticClass:"question-image"},[_c('img',{staticClass:"image-content",attrs:{"src":_vm.disableCache(_vm.question.image)}}),_c('h2',{staticClass:"image-title"},[_vm._v(_vm._s(_vm.question.texts[_vm.lang]))])]):_c('h2',{staticClass:"question-only-title"},[_vm._v(_vm._s(_vm.question.texts[_vm.lang]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }